//
//
//
//
//
//
//
//
//
//
//
//
//
import { MU_UPATE_AUTH } from "store/index";
import siteInfo from "page/xSchool/siteManager/siteInfo.vue";
import PassWordEdit from "page/xSchool/manager/PassWordEdit.vue";
export default {
  data: function data() {
    return {
      tabName: "first"
    };
  },
  components: {
    siteInfo: siteInfo,
    PassWordEdit: PassWordEdit
  },
  created: function created() {
    var that = this;

    if (localStorage["userId"] !== undefined) {
      that.$store.dispatch(MU_UPATE_AUTH).then(function (rt) {});
    }
  },
  methods: {
    handleClick: function handleClick(tab, event) {
      console.log(tab, event);
    }
  },
  computed: {}
};